import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
const PrintHeader = styled.div.withConfig({
  displayName: "WidgetPrintHeader__PrintHeader",
  componentId: "r44wil-0"
})(["border:0.2em solid;border-color:", ";display:flex;justify-content:center;margin:3rem 1rem 1rem 1rem;text-transform:uppercase;letter-spacing:0.0625em;font-weight:normal;@media print{border-color:", ";}"], props => props.theme.palette.common.white, props => props.theme.palette.common.black);
export const WidgetPrintHeader = ({
  title,
  printConfig
}) => {
  let header;

  if (typeof title !== 'string') {
    if (printConfig && printConfig.fromDate && printConfig.toDate) {
      const {
        fromDate,
        toDate
      } = printConfig;
      header = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, title, {
        values: {
          fromDate,
          toDate
        }
      }));
    } else {
      // possibility to print all dates - date range
      // trimming the from {fromDate} to {toDate} part => 28
      // TODO needs to be fixed at the source
      // Example: "Measures from {fromDate} to {toDate}"
      const msg = title.defaultMessage;
      header = msg.substring(0, msg.length - 28);
    }
  } else {
    header = title;
  }

  return /*#__PURE__*/React.createElement(PrintHeader, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, header));
};
export default WidgetPrintHeader;